export default {
  tollFree: 'Toll-Free',
  rcvPmiMeetingTitle: "{extensionName}'s video meeting",
} as const;
